import { NavLink, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { CalendarView } from "./CalendarView";
import { ChecklistsView } from "./ChecklistsView";
import { HorizonsView } from "./HorizonsView";
import { InboxView } from "./InboxView";
import { NextView } from "./NextView";
import { ProjectNextHint } from "./projectHint";
import { ProjectsView } from "./ProjectsView";
import { ReferencesView } from "./ReferencesView";
import { SomedayView } from "./SomedayView";
import { WaitingView } from "./WaitingView";

const TABS = [
  { path: "inbox", label: "Inbox" },
  { path: "next", label: "Next" },
  { path: "projekty", label: "Projekty" },
  { path: "waiting", label: "Waiting" },
  { path: "kiedys", label: "Kiedyś" },
  { path: "checklisty", label: "Checklisty" },
  { path: "referencje", label: "Referencje" },
  { path: "horyzonty", label: "Horyzonty" },
  { path: "kalendarz", label: "Kalendarz" },
];

/** Nested routes so the back button walks between lists (PLAN §8). */
export function ListsPage() {
  return (
    <Routes>
      <Route element={<ListsShell />}>
        <Route index element={<Navigate to="inbox" replace />} />
        <Route path="inbox" element={<InboxView />} />
        <Route path="next" element={<NextView />} />
        <Route path="projekty" element={<ProjectsView />} />
        <Route path="waiting" element={<WaitingView />} />
        <Route path="kiedys" element={<SomedayView />} />
        <Route path="checklisty" element={<ChecklistsView />} />
        <Route path="referencje" element={<ReferencesView />} />
        <Route path="horyzonty" element={<HorizonsView />} />
        <Route path="kalendarz" element={<CalendarView />} />
        <Route path="*" element={<Navigate to="inbox" replace />} />
      </Route>
    </Routes>
  );
}

function ListsShell() {
  return (
    <div className="lists">
      <nav className="tabs" aria-label="Listy">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) => `tabs__item ${isActive ? "tabs__item--active" : ""}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <ProjectNextHint />
      <Outlet />
    </div>
  );
}
